<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <!-- <el-form-item label="会议名称">
          <el-input placeholder="请输入会议名称" v-model="formInline.name" style="width: 180px;"></el-input>
        </el-form-item> -->
        <el-form-item label="所属组织">
          <el-select v-model="formInline.affiliated_organization" placeholder="请选择所属组织" clearable style="width: 180px;">
            <el-option label="所有" value=""></el-option>
            <el-option v-for="item in companyList" :key="item.ma_company_id" :label="item.name" :value="item.ma_company_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会议状态">
          <el-select v-model="formInline.meeting_status" placeholder="请选择会议状态" clearable style="width: 180px;">
            <el-option label="所有" value=""></el-option>
            <el-option label="未开始" value="0"></el-option>
            <el-option label="进行中" value="1"></el-option>
            <el-option label="已结束" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会议分类">
          <el-select v-model="formInline.meeting_category" placeholder="请选择会议分类" clearable style="width: 180px;">
            <el-option label="所有" value=""></el-option>
            <el-option v-for="item in conferenceClassificationList" :key="item.ma_conference_classification_id" :label="item.name" :value="item.ma_conference_classification_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属行业">
          <el-input placeholder="请输入所属行业" v-model="formInline.industry" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="适用岗位">
          <el-input placeholder="请输入适用岗位" v-model="formInline.applicable_position" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="会议模式">
          <el-select v-model="formInline.meeting_mode" placeholder="请选择会议模式" clearable style="width: 180px;">
            <el-option label="所有" value=""></el-option>
            <el-option label="远程会议" value="远程会议"></el-option>
            <el-option label="现场会议" value="现场会议"></el-option>
          </el-select>
        </el-form-item>
      
        <el-form-item label="发布组织">
          <el-select v-model="formInline.publish_organization" placeholder="请选择发布组织" clearable style="width: 180px;">
            <el-option label="所有" value=""></el-option>
            <el-option v-for="item in companyList" :key="item.ma_company_id" :label="item.name" :value="item.ma_company_id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="会议标签">
          <el-input placeholder="请输入会议标签" v-model="formInline.meeting_tags" style="width: 180px;"></el-input>
        </el-form-item> -->
        <el-form-item label="会议时间">
          <el-date-picker
            v-model="formInline.meeting_time_range"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 280px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          <!-- <el-button size="small" icon="el-icon-download" @click="exportData">导出Excel{{ selectedRows.length > 0 ? '(' + selectedRows.length + ')' : '' }}</el-button>
          <el-button size="small" icon="el-icon-upload2" @click="importClick">导入</el-button> -->
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">新增安全例会</el-button>
      <el-button size="small" icon="el-icon-edit" type="success" @click="addRecordClick">新增补录例会</el-button>
      <el-tooltip content="请选择勾选会议，仅能勾选一个会议" placement="top">
        <span class="print-btn-wrap">
          <el-button size="small" icon="el-icon-printer" :disabled="selectedRows.length !== 1" @click="printClick">打印</el-button>
        </span>
      </el-tooltip>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45"></el-table-column>

            <!-- <el-table-column prop="name" label="新建会议名称"></el-table-column> -->
            <el-table-column prop="affiliated_organization" label="所属组织">
              <template slot-scope="scope">
                {{ getCompanyName(scope.row.affiliated_organization) }}
              </template>
            </el-table-column>
            <el-table-column prop="meeting_category" label="会议分类"></el-table-column>
            <el-table-column prop="meeting_introduction" label="会议简介"></el-table-column>
            <el-table-column prop="meeting_host" label="会议主持人"></el-table-column>
            <el-table-column prop="meeting_recorder" label="会议记录人"></el-table-column>
            <el-table-column prop="meeting_time" label="会议时间"></el-table-column>
            <!-- <el-table-column prop="participants" label="参会人员"></el-table-column> -->
            <!-- <el-table-column prop="meeting_mode" label="会议模式"></el-table-column> -->
            <!-- <el-table-column prop="meeting_content" label="会议内容"></el-table-column> -->
            <!-- <el-table-column prop="meeting_image" label="图片"></el-table-column> -->
            <el-table-column prop="meeting_place" label="会议地点"></el-table-column>
            <!-- <el-table-column prop="attachments" label="文件上传（附件）"></el-table-column> -->

            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="200">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="manageCheckIn(scope.row)" type="text" size="small">签到人员</el-button>
                <el-button @click="manageCheckOut(scope.row)" type="text" size="small">签退人员</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" :meeting_type="meetingType" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :ma_new_meeting_id="ma_new_meeting_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Import :open_import="open_import" v-if="open_import" @close="closeImport"></Import>
    <CheckInPerson :open_check_in="open_check_in" :ma_new_meeting_id="ma_new_meeting_id" @close="closeCheckIn"></CheckInPerson>
    <CheckOutPerson :open_check_out="open_check_out" :ma_new_meeting_id="ma_new_meeting_id" @close="closeCheckOut"></CheckOutPerson>
    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible'
                :close-on-click-modal="false"
                :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>

    <!-- 打印预览弹窗 -->
    <el-dialog title="打印预览" :visible.sync="printDialogVisible" width="70%" @close="closePrintDialog" class="print-preview-dialog" append-to-body>
      <div ref="printContent" class="print-content">
        <div class="print-meeting-name">
          <span class="print-label">会议名称：</span>
          <span class="print-value">{{ printMeeting ? printMeeting.meeting_introduction : '—' }}</span>
        </div>
        <div class="print-list-label">签到列表</div>
        <div class="print-list-box">
          <el-table size="small" :data="printCheckInList" border style="width: 100%" v-loading="printLoading">
            <el-table-column label="注册照图片" width="100" align="center">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.yg_image"
                  style="width: 50px; height: 50px"
                  :src="scope.row.yg_image"
                  fit="cover"
                />
                <span v-else class="text-placeholder">—</span>
              </template>
            </el-table-column>
            <el-table-column prop="employee_name" label="员工姓名" width="120"></el-table-column>
            <el-table-column label="会议签名图片" width="100" align="center">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.signature"
                  style="width: 50px; height: 50px"
                  :src="scope.row.signature"
                  fit="cover"
                />
                <span v-else class="text-placeholder">—</span>
              </template>
            </el-table-column>
            <el-table-column prop="meeting_name" label="会议名称" width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="check_in_time" label="进入时间" width="160"></el-table-column>
            <el-table-column prop="check_out_time" label="退出时间" width="160"></el-table-column>
            <el-table-column label="现场照图片" width="100" align="center">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.check_in_image"
                  style="width: 50px; height: 50px"
                  :src="scope.row.check_in_image"
                  fit="cover"
                />
                <span v-else class="text-placeholder">—</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closePrintDialog">取消</el-button>
        <el-button type="primary" icon="el-icon-printer" @click="doPrint">打印</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Ma_new_meetingApi from '@/api/ma_new_meeting.js';
import Ma_companyApi from '@/api/ma_company.js';
import Ma_conference_classificationApi from '@/api/ma_conference_classification.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';
import Import from './part/import.vue';
import CheckInPerson from './part/CheckInPerson.vue';
import CheckOutPerson from './part/CheckOutPerson.vue';

export default {
  components: {
    Add,
    Edit,
    Import,
    CheckInPerson,
    CheckOutPerson
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        name: "",
        affiliated_organization: "",
        meeting_category: "",
        industry: "",
        applicable_position: "",
        meeting_mode: "",
        meeting_cycle: "",
        publish_organization: "",
        meeting_tags: "",
        meeting_time_range: []
      },
      companyList: [],
      conferenceClassificationList: [],

      open_add:false,
      open_edit:false,
      open_check_in: false,
      open_check_out: false,
      ma_new_meeting_id:"",
      meetingType: 1,
      dialogVisible:false,
      open_import:false,
      /*选中的*/
      selection: [],
      selectedRows: [], // 选中的行数据
      /* 打印预览 */
      printDialogVisible: false,
      printMeeting: null,
      printCheckInList: [],
      printLoading: false
    };
  },
  created() {
    this.loadCompanies();
    this.loadConferenceClassifications();
    this.getTableList();
  },
  methods: {
    loadCompanies() {
      let self = this;
      Ma_companyApi.list({}, true)
          .then(data => {
            if (data.code == 1) {
              self.companyList = data.data.list.data;
            }
          })
          .catch(error => {
          });
    },

    loadConferenceClassifications() {
      let self = this;
      Ma_conference_classificationApi.list({}, true)
          .then(data => {
            if (data.code == 1) {
              self.conferenceClassificationList = data.data.list.data;
            }
          })
          .catch(error => {
          });
    },

    dialogFormVisible(){
      this.dialogVisible = false;
    },

    getCompanyName(companyId) {
      if (!companyId) return '-';
      const company = this.companyList.find(item => item.ma_company_id === companyId);
      return company ? company.name : companyId;
    },

    setting(e){//新建会议标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
    /* 多选框选择变化 */
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    /* 清空选择 */
    clearSelection() {
      if (this.multipleTable) {
        this.multipleTable.clearSelection();
      }
      this.selectedRows = [];
    },
    closeImport(e) {
      this.open_import = false;
      if (e.type === "success") {
        this.getTableList(); // 导入成功后刷新列表
      }
    },
    importClick() {
      this.open_import = true;
    },
    exportData() {
      let exportParams = {
        name: this.formInline.name,
        affiliated_organization: this.formInline.affiliated_organization,
        meeting_category: this.formInline.meeting_category,
        industry: this.formInline.industry,
        applicable_position: this.formInline.applicable_position,
        meeting_mode: this.formInline.meeting_mode,
        meeting_cycle: this.formInline.meeting_cycle,
        publish_organization: this.formInline.publish_organization,
        meeting_tags: this.formInline.meeting_tags
      };

      if (this.formInline.meeting_time_range && this.formInline.meeting_time_range.length === 2) {
        exportParams.meeting_time_start = this.formInline.meeting_time_range[0];
        exportParams.meeting_time_end = this.formInline.meeting_time_range[1];
      }

      if (this.selectedRows.length > 0) {
        const selectedIds = this.selectedRows.map(row => row.ma_new_meeting_id);
        exportParams.selected_ids = selectedIds.join(',');
      }

      let baseUrl = window.location.protocol + '//' + window.location.host;
      let queryString = Object.keys(exportParams)
          .filter(key => exportParams[key] !== '' && exportParams[key] !== undefined && exportParams[key] !== null)
          .map(key => `${key}=${encodeURIComponent(exportParams[key])}`)
          .join('&');

      window.location.href = baseUrl + '/index.php/shop/plus.ma_new_meeting.Index/export?' + queryString;
    },
    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;

      if (Params.meeting_time_range && Params.meeting_time_range.length === 2) {
        Params.meeting_time_start = Params.meeting_time_range[0];
        Params.meeting_time_end = Params.meeting_time_range[1];
      }
      delete Params.meeting_time_range;

      self.loading = true;
      Ma_new_meetingApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
    },

    /*重置搜索*/
    resetSearch() {
      this.formInline = {
        name: "",
        affiliated_organization: "",
        meeting_status: "",
        meeting_category: "",
        industry: "",
        applicable_position: "",
        meeting_mode: "",
        meeting_cycle: "",
        publish_organization: "",
        meeting_tags: "",
        meeting_time_range: []
      };
      this.curPage = 1;
      this.getTableList();
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.meetingType = 1;
      this.open_add = true
    },

    /*新增补录例会*/
    addRecordClick() {
      this.meetingType = 2;
      this.open_add = true
    },

    /* 打印：仅勾选一个会议时可用 */
    printClick() {
      if (this.selectedRows.length !== 1) {
        this.$message.warning('请勾选一个会议');
        return;
      }
      this.printMeeting = this.selectedRows[0];
      this.printDialogVisible = true;
      this.loadPrintCheckInList();
    },

    loadPrintCheckInList() {
      let self = this;
      if (!self.printMeeting || !self.printMeeting.ma_new_meeting_id) return;
      self.printLoading = true;
      Ma_new_meetingApi.getCheckInList({ ma_new_meeting_id: self.printMeeting.ma_new_meeting_id }, true)
        .then(data => {
          self.printLoading = false;
          if (data.code === 1) {
            const list = data.data.list;
            const rawList = (list && list.data) ? list.data : (list || []);
            self.printCheckInList = rawList.map(item => ({
              ...item,
              yg_image: item.yg_image != null ? item.yg_image : (item.avatar != null ? item.avatar : ''),
              employee_name: item.employee_name != null ? item.employee_name : (item.name != null ? item.name : ''),
              signature: item.signature != null ? item.signature : '',
              meeting_name: item.meeting_name != null ? item.meeting_name : (item.meeting_title != null ? item.meeting_title : ''),
              check_in_time: item.check_in_time != null ? item.check_in_time : (item.sign_in_time != null ? item.sign_in_time : ''),
              check_out_time: item.check_out_time != null ? item.check_out_time : (item.sign_out_time != null ? item.sign_out_time : ''),
              check_in_image: item.check_in_image != null ? item.check_in_image : (item.scene_image != null ? item.scene_image : '')
            }));
          }
        })
        .catch(() => {
          self.printLoading = false;
        });
    },

    closePrintDialog() {
      this.printDialogVisible = false;
      this.printMeeting = null;
      this.printCheckInList = [];
    },

    doPrint() {
      const printNode = this.$refs.printContent;
      if (!printNode) return;
      const win = window.open('', '_blank');
      if (!win) {
        this.$message.warning('请允许弹窗以进行打印');
        return;
      }
      win.document.write('<html><head><meta charset="utf-8"><title>会议签到列表</title><style>body{font-family:Microsoft YaHei,sans-serif;padding:20px;} table{width:100%;border-collapse:collapse;} th,td{border:1px solid #ddd;padding:8px;text-align:left;} th{background:#f5f5f5;} .print-label{font-weight:bold;} .print-list-label{margin:16px 0 8px;font-weight:bold;} .print-list-box{margin-top:8px;} img{max-width:50px;max-height:50px;}</style></head><body>');
      win.document.write(printNode.innerHTML);
      win.document.write('</body></html>');
      win.document.close();
      win.onload = function() { win.print(); win.close(); };
    },

    /*编辑活动*/
    editClick(row) {
      this.ma_new_meeting_id = row.ma_new_meeting_id;
      this.open_edit = true
    },

    manageCheckIn(row) {
      this.ma_new_meeting_id = row.ma_new_meeting_id;
      this.open_check_in = true;
    },

    manageCheckOut(row) {
      this.ma_new_meeting_id = row.ma_new_meeting_id;
      this.open_check_out = true;
    },

    closeCheckIn() {
      this.open_check_in = false;
    },

    closeCheckOut() {
      this.open_check_out = false;
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Ma_new_meetingApi.del(
                {
                  ma_new_meeting_id: row.ma_new_meeting_id
                },
                true
            )
                .then(data => {
                  if (data.code == 1) {
                    self.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                    this.getTableList();
                  } else {
                    self.$message.error('错了哦，这是一条错误消息');
                  }
                })
                .catch(error => {
                });
          })
          .catch(() => {
          });
    }
  }
};
</script>

<style lang="scss" scoped>
.print-btn-wrap {
  display: inline-block;
}
.print-content {
  .print-meeting-name {
    margin-bottom: 12px;
    .print-label {
      font-weight: bold;
      color: #303133;
    }
    .print-value {
      color: #606266;
    }
  }
  .print-list-label {
    font-weight: bold;
    color: #303133;
    margin-bottom: 8px;
  }
  .print-list-box {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 12px;
    min-height: 120px;
  }
  .text-placeholder {
    color: #c0c4cc;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_new_meeting/index/index.vue